
/* injects from baggage-loader */

'use strict';

import ProductCreatorVideosController from './product-creator.videos.controller';
import ProductCreatorVideosTemplate from './product-creator.videos.html';

export default class ProductCreatorVideosComponent {
		constructor() {
				this.templateUrl = ProductCreatorVideosTemplate;
				this.controller = ProductCreatorVideosController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					product: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/product-creator/videos/product-creator.videos.component.js